import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, useAttrs } from 'vue';
import { TextArea as KTextArea } from '@progress/kendo-vue-inputs';


export default /*@__PURE__*/_defineComponent({
  __name: 'TextArea',
  props: /*@__PURE__*/_mergeModels({
    width: { default: undefined },
    showClearButton: { type: Boolean, default: true }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {

const model = _useModel<string | number | undefined>(__props, "modelValue");

const props = __props;

const attrs = useAttrs();
const mergedAttrs = computed(() => ({
    ...attrs,
    testid: attrs.testid ?? 'textarea',
}));

const kTextAreaRef = ref<InstanceType<typeof KTextArea> | null>(null);

function handleChange() { }

__expose({
    focus: () => kTextAreaRef.value?.focus?.(),
    get element() {
        const ref = kTextAreaRef.value;
        if (!ref) return undefined;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (ref as any).$el || (ref as { element?: HTMLElement }).element;
    },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(KTextArea), _mergeProps({
    ref_key: "kTextAreaRef",
    ref: kTextAreaRef
  }, mergedAttrs.value, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    role: "textbox",
    style: { width: props.width },
    "show-clear-button": __props.showClearButton,
    onInput: handleChange
  }), _createSlots({ _: 2 }, [
    _renderList(_ctx.$slots, (_, name) => {
      return {
        name: name,
        fn: _withCtx((slotProps) => [
          _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(slotProps)))
        ])
      }
    })
  ]), 1040, ["modelValue", "style", "show-clear-button"]))
}
}

})